import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { StyledFooterContainer, StyledFooterWrapper, StyledFooterDivider, StyledFooterDescription, StyledFooterNav } from './Footer.styled';
import LogoImage from "../../assets/images/logo.png"

const Footer = () => {

    return (
        <StyledFooterContainer>
            <StyledFooterWrapper>
                <StyledFooterDescription>
                    <img src={LogoImage} alt="Logo image" style={{ width: 'fit-content' }} />
                    <p style={{ fontSize: '16px', fontWeight: '400', color: 'white' }}>Goofy Giraffes is an NFT Collection on Solana. Each trait was hand drawn by founder Joe and his mother Michelle dedicated to Michelle’s sister Kathy who loved Giraffes. The collection aims to provide multiple streams of revenue to holders through Gambling, Investing, and Sports betting features. Participate in Massive Poker events, contests, tournaments, giveaways, and more! </p>
                </StyledFooterDescription>
                <StyledFooterNav>
                    <h3 style={{ fontSize: '20px', fontWeight: '400', color: 'white' }}>Social Links</h3>
                    <Link to="https://x.com/goofygiraffes_?s=21" target='_blank'><h5 style={{ fontSize: '16px', fontWeight: '400', color: 'white', margin: 0 }}>Twitter</h5></Link>
                    <Link to="https://discord.com/invite/pMawhBZj5b" target='_blank'><h5 style={{ fontSize: '16px', fontWeight: '400', color: 'white', margin: 0 }}>Discord</h5></Link>
                    <Link to="https://stake.mobtools.in/goofy_giraffes" target='_blank'><h5 style={{ fontSize: '16px', fontWeight: '400', color: 'white', margin: 0 }}>Goofy Staking</h5></Link>
                </StyledFooterNav>
                <StyledFooterNav>
                    <h3 style={{ fontSize: '20px', fontWeight: '400', color: 'white' }}>Pages</h3>
                    <Link to="/"><h5 style={{ fontSize: '16px', fontWeight: '400', color: 'white', margin: 0 }}>Home</h5></Link>
                    <Link to="/leaderboard"><h5 style={{ fontSize: '16px', fontWeight: '400', color: 'white', margin: 0 }}>Leaderboard</h5></Link>
                    <Link to="/sports-picks"><h5 style={{ fontSize: '16px', fontWeight: '400', color: 'white', margin: 0 }}>Sports Picks</h5></Link>
                </StyledFooterNav>
            </StyledFooterWrapper>
            <StyledFooterDivider></StyledFooterDivider>
            <StyledFooterWrapper>
                <h5 style={{ fontSize: '20px', color: 'white', fontWeight: '400' }}>Copyright @ 2024 Goofy Giraffes</h5>
            </StyledFooterWrapper>
        </StyledFooterContainer>
    );
}

export default Footer;
